import React, { useState } from "react";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { collection, query, where, getDocs, setDoc } from "firebase/firestore";
import { db } from "../firebase/firebase"; // Firestore-Instanz
import { getAuth } from "firebase/auth"; // Firebase Authentication
import { useParams } from "react-router-dom";

function ImageUploadPage() {
    const { link } = useParams(); // Link aus den URL-Parametern
    const [uploadedImage, setUploadedImage] = useState(null);
    const [uploading, setUploading] = useState(false);

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploading(true);

        const storage = getStorage(); // Firebase Storage Instanz
        const filePath = `images/${Date.now()}-${file.name}`; // Speicherort in Firebase Storage
        const storageRef = ref(storage, filePath); // Referenz zum Speicherort
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload ist ${progress}% fertig`);
            },
            (error) => {
                console.error("Fehler beim Upload:", error);
                alert("Fehler beim Hochladen.");
                setUploading(false);
            },
            async () => {
                // URL der hochgeladenen Datei abrufen
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                setUploadedImage(downloadURL);
                console.log("Download-URL:", downloadURL);

                // In Firestore speichern
                const auth = getAuth();
                const currentUser = auth.currentUser;

                if (currentUser) {
                    try {
                        // Referenz zur Sammlung
                        const pagesRef = collection(db, "pages");
                
                        // Query erstellen, um das Dokument mit dem passenden Link zu finden
                        const q = query(pagesRef, where("link", "==", link));
                
                        // Query ausführen
                        const querySnapshot = await getDocs(q);
                
                        if (querySnapshot.empty) {
                            console.error(`Keine Seite mit link = ${link} gefunden.`);
                            alert("Seite nicht gefunden.");
                            return;
                        }
                
                        // Da `link` unique ist, sollte nur ein Dokument zurückgegeben werden
                        const pageDoc = querySnapshot.docs[0];
                        const pageRef = pageDoc.ref;
                
                        // Aktualisiere das Dokument
                        await setDoc(
                            pageRef,
                            {
                                contentType: "image",
                                content: {
                                    image: downloadURL,
                                },
                                ownerId: currentUser.uid,
                                updatedAt: new Date(),
                            },
                            { merge: true }
                        );
                
                        alert("Bild erfolgreich hochgeladen und gespeichert!");
                    } catch (error) {
                        console.error("Fehler beim Speichern der Seite:", error);
                        alert("Fehler beim Speichern der Seite.");
                    }
                } else {
                    alert("Du musst angemeldet sein, um das Bild zu speichern.");
                }
                

                setUploading(false);
            }
        );
    };

    return (
        <div className="container d-flex flex-column align-items-center mt-5">
            <h1 className="mb-4">Bild hochladen</h1>
            <div className="mb-3">
                <label htmlFor="imageUpload" className="btn btn-primary">
                    {uploading ? "Uploading..." : "Upload New"}
                </label>
                <input
                    type="file"
                    id="imageUpload"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImageUpload}
                    disabled={uploading}
                />
            </div>
            {uploadedImage && (
                <div className="mt-4">
                    <h5>Aktuell hochgeladenes Bild:</h5>
                    <img
                        src={uploadedImage}
                        alt="Hochgeladenes Bild"
                        style={{
                            maxWidth: "100%",
                            height: "auto",
                            border: "1px solid #ccc",
                            padding: "10px",
                            borderRadius: "8px",
                        }}
                    />
                </div>
            )}
        </div>
    );
}

export default ImageUploadPage;
